import OrderIcon from 'components/icons/OrderIcon';
import { FC, useContext, useMemo } from 'react';
import styled from 'styled-components';
import GetOrderValue from 'types/GetOrderValue';
import { ListContext } from '.';

type Props = {
  name: string;
};
const ThWithProps: FC<Props> = ({ name, ...props }) => {
  const { activeColumns } = useContext(ListContext);
  return activeColumns[name] || name === 'checkbox' || name === 'settings' ? (
    <div {...props} />
  ) : null;
};

export const Th = styled(ThWithProps)`
  font-size: 0.9rem;
  padding: 0.8rem 1.5rem;
  font-weight: 500;
  text-align: left;
  display: flex;
  align-items: center;
  & > div {
    display: flex;
    font-size: 0.9rem;
    align-items: center;
  }
  user-select: none;
`;

type OrderProps<SortingValue extends string> = {
  name: SortingValue;
  order: string;
  setOrder: (order: GetOrderValue<SortingValue>) => void;
};
function getOrderThWithProps<SortingValue extends string>(): FC<
  OrderProps<SortingValue>
> {
  return ({ name, order, children, setOrder, ...props }) => {
    const { activeColumns } = useContext(ListContext);
    const sortingOrder: 'asc' | 'desc' | null = useMemo(() => {
      const split = order.split('/');
      if (split[1] === name) {
        if (split[0] === 'desc') {
          return 'desc';
        }
        return 'asc';
      }
      return null;
    }, [name, order]);

    const handleChange = () => {
      if (sortingOrder === 'asc') {
        return setOrder(`desc/${name}`);
      }
      return setOrder(`asc/${name}`);
    };
    return activeColumns[name] || name === 'checkbox' || name === 'settings' ? (
      <div {...props} onClick={handleChange}>
        {children} <OrderIcon sortingOrder={sortingOrder} />
      </div>
    ) : null;
  };
}

export function getOrderTh<SortingValue extends string>() {
  const OrderThWithProps = getOrderThWithProps<SortingValue>();
  return styled(OrderThWithProps)`
    font-size: 0.9rem;
    padding: 0.8rem 1.5rem;
    font-weight: 500;
    text-align: left;
    display: flex;
    align-items: center;
    & > div {
      display: flex;
      font-size: 0.9rem;
      align-items: center;
    }
    svg {
      margin-left: 0.5rem;
      height: 10px;
    }
    cursor: pointer;
    user-select: none;
  `;
}
